import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';

class Aboutus extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { trans } = this.props;
        return (
            <div>

                <Header trans={trans}
                    active="about us"
                    type="video"
                    title="The Team Behind HansaBot"
                    body="A journey started 2 years ago by 2 coffee-addicted friends in Melbourne">
                    <a href="#" className="button w-button">{trans('Get in touch with us')}</a>
                </Header>
                <div className="section _2-column-pricing tint">
                    <div className="container w-container">
                        <div className="w-row"><div className="image-block-column-left w-col w-col-6 w-col-stack">
                            <div className="image-block">
                                <div className="image-block-description">
                                </div>
                            </div>
                            </div>
                            <div className="overall-text-column w-col w-col-3 w-col-stack">
                                <div className="small-column-title">{trans('It all started 2 years ago')}</div>
                                <p>
                                    {trans('The co-founders, Lee and Huy were coffee-addicts like most Melbournians, we felt the need for automating pre-ordering workflow for these coffee shops. As we decided to create chatbots using existing builder platforms to no success, so we ended up creating a much better platform ourself, called HansaBot')}
                                </p>
                            </div>
                            <div className="overall-text-column w-col w-col-3 w-col-stack">
                                <div className="small-column-title">{trans('Chatbot Industry Pioneers')}</div>
                                <p>
                                    {trans('Unlike most platforms were created for the purpose of attracting the bespoken clients, we believe strongly in our platform and will build a strong community around it. There are not many other people out there as merited as us at understanding how chatbots should work and what values they can bring to a business')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section dark">
                    <div className="container centered w-container">
                        <a href="#" className="overall-video-lightbox large-hero w-inline-block w-lightbox">
                            <div className="video-lightbox-image-block hero">
                                <div className="video-lightbox-button">
                                    <img src="/static/images/59fed69e519aa5000146762c_Icon-play-white.png" className="video-lightbox-icon" />
                                </div>
                            </div>
                        </a>
                        <div className="section-title-wrapper full below-video">
                            <h2 className="section-title">
                                {trans('Want a custom chatbot for your bussiness')}
                            </h2>
                            <div className="section-description">
                                {trans('Get in touch with us')}
                            </div>
                        </div>
                        <a href="#" className="button w-button">{trans('Learn more')}</a>
                        <a href="#" className="button _2 green w-button">{trans('Contact us')}</a>
                    </div>
                </div>
                <div className="section">
                    <div className="container w-container">
                        <div className="w-row"><div className="text-column-left w-col w-col-6">
                            <div className="section-title-wrapper full info">
                                <h2 className="section-title">{trans('Come Work With Us')}</h2>
                            </div>
                            <p>
                                {trans('Would you like to join the team which empowers a powerful platform for the community? Do you take a professional pride in building great apps and chatbots that actually work for businesses? Come and work with us. We have offices in Australia and Vietnam')}
                            </p>
                            <div>{trans('Check out our job openings')}</div>
                            </div>
                            <div className="image-column-right w-col w-col-6">
                                <div className="image-block-right"></div>
                            </div>
                        </div>
                        <div className="top-line-block">
                            <div className="text-row w-row">
                                <div className="text-column w-clearfix w-col w-col-4">
                                    <img src="/static/images/59fed69e519aa50001467659_Icon-thumb-blue.png" className="small-column-icon" />
                                    <div className="text-column-title">{trans('High quality team')}</div>
                                    <p className="small-paragraph">
                                        {trans('The management members all have 10+ years experience working in Australian IT industry. We are a team that values Quality and Responsibility; a perfect mix of Australian professionalism and Vietnamese working spirit')}
                                    </p>
                                </div>
                                <div className="text-column w-clearfix w-col w-col-4">
                                    <img src="/static/images/59fed69e519aa500014675ee_Icon-camera-blue.png" className="small-column-icon" />
                                    <div className="text-column-title">{trans('UI and Ux MAsters')}</div>
                                    <p className="small-paragraph">
                                        {trans('The team takes pride in building great products with the top-notch UI and UX. We love receiving feedbacks and keep fine-tuning our products to satisfy the users and the customers')}
                                    </p>
                                </div>
                                <div className="text-column w-clearfix w-col w-col-4">
                                    <img src="/static/images/59fed69e519aa50001467637_Icon-pencil-blue.png" className="small-column-icon" />
                                    <div className="text-column-title">{trans('A Great learning culture')}</div>
                                    <p className="small-paragraph">
                                        {trans('We are still a young startup working in a very early and dynamic field. We are always open to new and edgy technologies. We like to think what we can do to drive the industry')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer trans={trans} />
            </div>
        )
    }

}

export default connect(state => ({

}), {

})(Aboutus);






// WEBPACK FOOTER //
// ./src/pages/Aboutus.js